// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import layer from 'v-layer/dist/v-layer'
import Axios from 'axios/dist/axios'
import lottery from 'vue-lottery'
Vue.prototype.axios = Axios
Vue.use(layer)
Vue.use(lottery)
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  render: h => h(App),
}).$mount('#app')

